import { api } from './client'

const timeEntryService = {
  getBillingEntries: async ({ matterId, limit = 50, offset = 0 } = {}) => {
    const params = { limit, offset }
    if (matterId) params.matterId = matterId
    const resp = await api.get('/billing-entries', params)
    return { entries: resp.data, total: resp.meta.total }
  },

  getRecentEntries: async ({ beforeDate, limit = 200 } = {}) => {
    const params = { limit }
    if (beforeDate) params.before = beforeDate
    const resp = await api.get('/billing-entries', params)
    return resp.data
  },

  getEntriesForRange: async (startDate, endDate) => {
    const resp = await api.get('/billing-entries', { after: startDate, before: endDate, limit: 500 })
    return resp.data
  },

  saveTimeEntry: async (entry) => {
    const resp = await api.post('/billing-entries', entry)
    return resp.data
  },

  /** Get billing codes (time or expense) for dropdowns */
  getBillingCodes: async (entryType) => {
    const params = entryType ? { entry_type: entryType } : {}
    const resp = await api.get('/billing-entries/codes', params)
    return resp.data
  },

  /** Parse natural language into structured billing entry via AI */
  parseEntry: async (text) => {
    const resp = await api.post('/billing-entries/parse', { text })
    return resp.data
  },

  /** Extract data from receipt image via Claude vision */
  extractReceipt: async (file) => {
    const formData = new FormData()
    formData.append('receipt', file)
    const resp = await api.postFormData('/billing-entries/receipt', formData)
    return resp.data
  },

  /** Transcribe audio to text via Workers AI Whisper */
  transcribe: async (audioBlob) => {
    const formData = new FormData()
    formData.append('audio', audioBlob, 'recording.webm')
    const resp = await api.postFormData('/billing-entries/transcribe', formData)
    return resp.data
  },

  getActiveTimer: async () => {
    const resp = await api.get('/timers/active')
    return resp.data
  },

  stopTimer: async ({ timerId, description } = {}) => {
    return api.post('/timers/stop', { timerId, description })
  },
}

export default timeEntryService
